import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './IndianAgricultureNews.css'; // Optional styling
import { useTranslation } from '../../translations/useTranslation';

const AgricultureNews = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('agriculture OR farming OR farmer');
  const { t } = useTranslation();

  // API key - in production, store this in environment variables
  const API_KEY = '0586565d34434740b72dee51f83821f0'; // Replace with your actual API key
  // const API_URL = `https://newsapi.org/v2/everything?q=${encodeURIComponent(searchTerm)}&language=hi&sortBy=publishedAt&apiKey=${API_KEY}`;

  const API_URL = `https://api.agromanch.com/api/news?q=${encodeURIComponent(searchTerm)}`;

  useEffect(() => {
    const fetchNews = async () => {
      try {
        setLoading(true);
        const response = await axios.get(API_URL);
        setNews(response.data.articles);
        setError(null);
      } catch (err) {
        setError(t('failedToFetchNews'));
        console.error('Error fetching news:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, [searchTerm]);

  const handleSearch = (e) => {
    e.preventDefault();
    const newSearchTerm = e.target.search.value;
    if (newSearchTerm.trim()) {
      setSearchTerm(newSearchTerm);
    }
  };

  return (
    <div className="agriculture-news-container">
      <header className="news-header">
        <h1>{t('agricultureFarmerNews')}</h1>
        <p>{t('latestAgricultureUpdates')}</p>
        
        <form onSubmit={handleSearch} className="search-form">
          <input
            type="text"
            name="search"
            placeholder={t('searchNewsPlaceholder')}
            defaultValue={searchTerm}
          />
          <button type="submit">{t('search')}</button>
        </form>
      </header>

      {loading && <div className="loading">{t('loadingNews')}</div>}
      
      {error && <div className="error">{error}</div>}
      
      {!loading && !error && (
        <div className="news-grid">
          {news.length > 0 ? (
            news.map((article, index) => (
              <article key={index} className="news-card">
                {article.urlToImage && (
                  <div className="news-image">
                    <img src={article.urlToImage} alt={article.title} />
                  </div>
                )}
                <div className="news-content">
                  <h2>{article.title}</h2>
                  <p className="news-description">{article.description}</p>
                  <div className="news-meta">
                    <span className="source">{article.source.name}</span>
                    <span className="date">
                      {new Date(article.publishedAt).toLocaleDateString()}
                    </span>
                  </div>
                  <a
                    href={article.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="read-more"
                  >
                    {t('readMore')}
                  </a>
                </div>
              </article>
            ))
          ) : (
            <p>{t('noNewsFound')}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default AgricultureNews;